/**
 * Purchase Card Wrapper
 * Wraps the price, variants, quantity, and buy buttons in a grey card
 */

document.addEventListener('DOMContentLoaded', function() {
  const productInfo = document.querySelector('.product__info-container, product-info');

  if (!productInfo) return;

  // Find the purchase elements
  const priceElement = productInfo.querySelector('[id*="price-"]');
  const buyButtonsForm = productInfo.querySelector('.product-form, product-form');

  if (!priceElement || !buyButtonsForm) return;

  // Create wrapper
  const wrapper = document.createElement('div');
  wrapper.className = 'purchase-card-wrapper';

  // Find all elements between price and buy buttons (inclusive)
  const elementsToWrap = [];
  let currentElement = priceElement;
  let foundBuyButtons = false;

  // Collect all sibling elements from price to buy buttons
  while (currentElement && !foundBuyButtons) {
    elementsToWrap.push(currentElement);

    // Check if this is the buy buttons or contains them
    if (currentElement.contains(buyButtonsForm) || currentElement === buyButtonsForm || currentElement.classList.contains('product-form')) {
      foundBuyButtons = true;
    }

    currentElement = currentElement.nextElementSibling;
  }

  // If we couldn't find a clear path, try a different approach
  if (elementsToWrap.length === 0) {
    // Fallback: wrap from first price-related element to last form element
    const allPurchaseElements = productInfo.querySelectorAll('[id*="price"], .product-form__input, .quantity, .product-form, product-form, .product-form__buttons');

    if (allPurchaseElements.length > 0) {
      // Insert wrapper before first element
      allPurchaseElements[0].parentNode.insertBefore(wrapper, allPurchaseElements[0]);

      // Move all elements into wrapper
      allPurchaseElements.forEach(el => {
        wrapper.appendChild(el);
      });
    }
  } else {
    // Insert wrapper before the first element to wrap
    priceElement.parentNode.insertBefore(wrapper, priceElement);

    // Move elements into wrapper
    elementsToWrap.forEach(el => {
      wrapper.appendChild(el);
    });
  }

});
